export enum SubMenu {
  teregistrasi = 'Teregistrasi',
  pending = 'Sedang Menunggu',
  reject = 'Ditolak',
}

export enum StatusDetailPrivilage {
  teregistrasi = 'DETAIL_REGISTERED',
  pending = 'DETAIL_PENDING',
  reject = 'DETAIL_REJECT',
}
